export const name = {
	threatAndAlertsNasaAndInpe: 'threatAndAlertsNasaAndInpe'
};
